const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/fields/EintrittsgrundField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const EintrittsgrundField = generateMetaKatDropDownField(
    'ae355f56-e76f-47c9-84f3-d36f98c151df',
    'EintrittsgrundField'
);
